<template>
	<el-dialog title="报验详情" :close-on-click-modal="false" :visible.sync="subVisible" width="922px">
		<el-row class="kind_row">
			<!-- <el-col :span="8">
				<span class="kind_label">标的物</span>
				<span class="kind_value_left">{{ subjectName }}</span>
			</el-col> -->
			<el-col :span="12">
				<span class="kind_label">时间</span>
				<span class="kind_value_right">{{ logDate }}</span>
			</el-col>
		</el-row>
		<el-table :row-style="selectRowBackground" :row-class-name="tableRowClassName" ref="dataListTable"
			class="dataListTable" :data="dataList" header-align="center" header-cell-class-name="dataListTHeader"
			@selection-change="handleSelectionChange" :cell-style="{ padding: '0px' }" style="margin-bottom: 20px;">
			<el-table-column type="selection" width="45" align="center"></el-table-column>
			<el-table-column label="No." width="70" align="center">
				<template slot-scope="scope">
					{{ (pageIndex2 - 1) * pageSize + scope.$index + 1 }}
				</template>
			</el-table-column>
			<el-table-column prop="workLogContext" label="内容" align="left" min-width="250" show-overflow-tooltip>
			</el-table-column>
			<el-table-column prop="" label="" align="center" width="150" show-overflow-tooltip>
				<template slot-scope="scope">
					{{ scope.row.testDate }}{{ scope.row.testMan }}
				</template>
			</el-table-column>
		</el-table>
		<el-pagination class="my-pagination" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"
			:current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
			layout="total, sizes, prev, pager, next, jumper">
		</el-pagination>
		<el-row class="formBtnGroup">
			<el-col :span="24">
				<el-button class="btn" type="primary" size="small" @click="dataSubmit()"
					:disabled="disabledSaved">保存</el-button>
			</el-col>
		</el-row>
	</el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
export default {
	name: "choose-progress-record",
	data() {
		return {
			subVisible: false,
			disabledSaved: true,
			logDate: '',
			subjectNo: '',
			tableSelVals: [],
			dataList: [],
			//当前页码
			pageIndex: 1,
			pageIndex2: 1,
			//当前记录数
			pageSize: 20,
			//总页数
			totalPage: 0,
			dataForm: {
				recNo: '',
				workLogRecNo: '',
				itemNo: '',
				sourceId: '',
				sourceType: 0,
				sort: 0,
				itemContent: '',
				updUserName: '',
			},
			itemNo: '',
			subjectName: '',
			subjectList: []
		};
	},
	methods: {
		init(workLogRecNo, sort, itemNo, subjectNo, logDate) {
			this.itemNo = itemNo
			this.dataForm = {
				recNo: '',
				workLogRecNo: workLogRecNo,
				itemNo: this.itemNo,
				sourceId: '',
				sourceType: '',
				sort: sort,
				itemContent: '',
				updUserName: $common.getItem("userName"),
				workNo: $common.getItem("workNo"),
			}
			this.subjectNo = subjectNo
			this.logDate = logDate
			this.$nextTick(() => {
				this.subVisible = true;
			})
			this.getSubjectDropDown()
			this.pageIndex2 = 1;
			this.getDataList();
		},
		getSubjectDropDown() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getSubjectDropDown/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.subjectList = data.body;
					for (var i = 0; i < this.subjectList.length; i++) {
						if (this.subjectList[i].displayValue === this.subjectNo) {
							this.subjectName = this.subjectList[i].displayName
							break;
						}
					}
				}
			});
		},
		// 获取数据列表
		getDataList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/testrecord/list",
				method: 'get',
				params: this.$http.adornParams({
					page: this.pageIndex,
					limit: this.pageSize,
					subjectNo: this.subjectNo,
					logDate: this.logDate,
					// primaryFlg: '1',
					workNo: $common.getItem("workNo"),
					conclusionIsNull: '1'
				})
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.dataList = data.body.records;
					this.totalPage = data.body.totalCount;
					this.pageIndex2 = this.pageIndex
				} else {
					this.dataList = []
					this.totalPage = 0
				}
			})
		},
		selGetDataList() {
			this.pageIndex = 1;
			this.getDataList();
		},
		// 每页数
		sizeChangeHandle(val) {
			this.pageSize = val;
			this.pageIndex = 1;
			this.getDataList();
		},
		// 当前页
		currentChangeHandle(val) {
			this.pageIndex = val;
			this.getDataList();
		},
		tableRowClassName({ row, rowIndex }) {
			return $common.tableRowClassName({ row, rowIndex });
		},
		selectRowBackground({ row }) {
			const checkIdList = this.tableSelVals.map((item) => item.testId);
			if (checkIdList.includes(row.testId)) {
				return {
					backgroundColor: "#fae8cb",
				};
			}
		},
		handleSelectionChange(selection) {
			this.tableSelVals = selection;
			if (selection.length > 0) {
				this.disabledSaved = false;
			} else {
				this.disabledSaved = true;
			}
		},
		dataSubmit() {
			let recordList = []
			for (var i = 0; i < this.tableSelVals.length; i++) {
				let record = {
					recNo: '',
					workLogRecNo: this.dataForm.workLogRecNo,
					subjectNo: this.subjectNo,
					itemNo: this.itemNo,
					sourceId:this.tableSelVals[i].testId,
					sourceType: '1',
					sort: this.dataForm.sort + i,
					itemContent: this.tableSelVals[i].workLogContext,
					updUserName: $common.getItem("userName"),
				}
				recordList.push(record)
			}
			let _url = "/business/worklogdetailinfo/saveBatch";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					recordList: recordList,
					workLogRecNo: this.dataForm.workLogRecNo
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
						onClose: () => {
							this.subVisible = false;
							this.$emit("refreshDataList");
						}
					});
				}
			});
		},
	}
};
</script>

<style scoped="scoped">
.kind_row {
	background-color: rgb(243, 247, 247);
	padding: 10px 0 10px 15px;
	margin-bottom: 10px;
}

.kind_label {
	color: black !important;
	font-weight: bold !important;
}

.kind_value_left {
	color: #3471b6 !important;
	font-weight: bold !important;
	margin-left: 10px;
}

.kind_value_right {
	color: black !important;
	margin-left: 20px !important;
}
</style>
